module.exports = __webpack_public_path__ + "img/Andromeda_thumb.c91ff56f.jpg";